import { Link } from "react-router-dom";
import { FiUpload, FiFilm, FiSearch } from "react-icons/fi";

const EmptyState = ({
  title = "No items found",
  description = "There's nothing to display here yet",
  icon = <FiFilm size={48} className="text-gray-400" />,
  action,
  searchQuery,
}) => {
  return (
    <div className="text-center py-12 px-4">
      <div className="mx-auto flex justify-center">
        {searchQuery ? (
          <div className="bg-gray-100 p-4 rounded-full">
            <FiSearch size={48} className="text-gray-400" />
          </div>
        ) : (
          icon
        )}
      </div>

      <h3 className="mt-4 text-lg font-medium text-gray-900">
        {searchQuery ? "No results found" : title}
      </h3>

      <p className="mt-2 text-gray-600 max-w-md mx-auto">
        {searchQuery
          ? `We couldn't find any videos matching "${searchQuery}". Try adjusting your search.`
          : description}
      </p>

      {action || (
        <div className="mt-6">
          <Link
            to="/infotainmentvideos/add"
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-yellow-500 hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
          >
            <FiUpload className="mr-2" />
            Upload New Video
          </Link>
        </div>
      )}
    </div>
  );
};

export default EmptyState;
